import React from "react"
import { useTranslation } from "react-i18next"
import ReactPlayer from "react-player"

import downloadIcon from "../../assets/common/download.svg"

const MultiTagRender = ({ contents, links }) => {
    const { t } = useTranslation()
    const regFileViewer = (contents) => {
        return contents && contents !== undefined && contents?.map((data) => {
            return <>
                { data?.regfile?.length > 0 &&
                    <h3 className={ `self-stretch text-primary-50 text-[18px] not-italic 
                    font-[800] leading-[24px] mt-[10px] pb-2` }>
                        { t("news.Documents") }
                    </h3>
                }
                { data?.regfile?.length > 0 && data?.regfile?.map((material, index) => {
                    return (<div key={ index } className={ `flex flex-col w-[100%] px-[16px] py-[8px] 
                    border solid border-lightGray rounded-lg` }>
                        <div id={ `file-${index + 1}` } className={ `text-secondary-200 
                            py-[8px] w-full ${(index + 1) !== data?.regfile.length ? 
                            "border-b solid border-lightGray" : ""}` }>
                            <a target="_blank" href={ material.url } className="w-full flex flex-row" rel="noreferrer">
                                <img
                                    src={ downloadIcon }
                                    className="w-[12px] h-[12px] flex-shrink-0"
                                    alt="downloadIcon"
                                    title="Download"
                                />
                                <div className="w-[99%] text-secondary-50 text-[12px] not-italic 
                                font-[350] leading-[14px] pl-[12px]">
                                    { material?.title ? material?.title : material?.fileName }
                                </div>
                            </a>
                        </div>
                    </div>)
                }) }
            </>
        }
        )
    }

    const renderHtmlRecursive = (contents, assets = {}, isparentCall = false) => {
        let isfirstcall = true

        return contents && contents !== undefined && contents?.map((subContents, index) => {
            const getClassName = generateClassNames(
                subContents?.marks,
                isparentCall,
                isfirstcall
            )
            isfirstcall = false

            let nodeType = ""
            if (subContents?.nodeType) {
                nodeType = subContents?.nodeType
            } else if (subContents?.json?.nodeType) {
                nodeType = subContents?.json?.nodeType
            }

            let content
            if (subContents?.content) {
                content = subContents?.content
            } else if (subContents?.json?.content) {
                content = subContents?.json?.content
            }
            switch (nodeType?.toLowerCase()) {

            case "h1":
            case "heading-1":
                return (
                    <h1 className={ `font-bold text-secondary-50 ${getClassName}` }>
                        { subContents?.value ? subContents?.value : subContents?.content?.[0]?.value }
                    </h1>
                )
            case "h2":
            case "heading-2":
                return (
                    <h2 className={ `font-bold text-secondary-50 ${getClassName}` }>
                        { subContents?.value ? subContents?.value : subContents?.content?.[0]?.value }
                    </h2>
                )
            case "h3":
            case "heading-3":
                return (<h3 className={ `font-bold text-secondary-50 ${getClassName}` }>
                    { subContents?.value ? subContents?.value : subContents?.content?.[0]?.value }
                </h3>)
            case "h4":
            case "heading-4":
                return (<h4 className={ `font-bold text-secondary-50 ${getClassName}` }>
                    { subContents?.value ? subContents?.value : subContents?.content?.[0]?.value }
                </h4>)
            case "h5":
            case "heading-5":
                return (<h5 className={ `font-bold text-secondary-50 ${getClassName}` }>
                    { subContents?.value ? subContents?.value : subContents?.content?.[0]?.value }
                </h5>)
            case "h6":
            case "heading-6":
                return (<h6 className={ `font-bold text-secondary-50 ${getClassName}` }>
                    { subContents?.value ? subContents?.value : subContents?.content?.[0]?.value }
                </h6>)
            case "document":
                return (
                    <>
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </>
                )
            case "paragraph":
                return (
                    <p className={ `${getClassName} text-secondary-200 text-base` }>
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </p>
                )
            case "text":
                return <span className={ getClassName }>{ subContents.value }</span>
            case "hyperlink":
                return (
                    <a
                        className={ `${getClassName} underline text-[#003da5]` }
                        href={ subContents?.data?.uri }
                        rel="noreferrer"
                        target={ "_blank" }
                    >
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </a>
                )
            case "table":
                return (
                    <table className={ `${getClassName} w-[70%] border rounded-lg border-secondary-300` }>
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </table>
                )
            case "table-row":
                return (
                    <tr
                        className={ `${getClassName} bg-slate-100` }
                        style={ { border: "1px solid #E2E3E5" } }
                    >
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </tr>
                )
            case "table-header-cell":
                return (
                    <th
                        className={ getClassName + 
                        " text-left px-1 border-secondary-200 bg-lightSkyblue text-primary-50" }
                        style={ {
                            border: "1px solid #E2E3E5",
                            paddingTop: "8px",
                            paddingBottom: "8px"
                        } }
                    >
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </th>
                )
            case "table-cell":
                return (
                    <td
                        className={ getClassName 
                            + " text-left px-1 border-secondary-200 py-[8px] border border-solid border-[#E2E3E5]" }
                        style={ {
                            border: "1px solid #E2E3E5",
                            paddingTop: "8px",
                            paddingBottom: "8px"
                        } }
                    >
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </td>
                )
            case "ordered-list":
                return (
                    <ol
                        className={ `${getClassName} flex flex-col list-decimal ml-[18px] text-base` }
                    >
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </ol>
                )
            case "unordered-list":
                return (
                    <ul
                        className={ `${getClassName} !mt-2 flex flex-col list-disc ml-[13px] px-[7px] text-base` }
                    >
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </ul>
                )
            case "list-item":
                return (
                    <li className={ `${getClassName}` }>
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </li>
                )

            case "blockquote":
                return (
                    <blockquote className={ `${getClassName} blockquoteClass` }>
                        { content?.length > 0 &&
                                renderHtmlRecursive(content) }
                    </blockquote>
                )

            case "embedded-asset-block": {
                const assetId = subContents?.data?.target?.sys?.id
                let finalAssets
                if(assets?.length > 0){
                    finalAssets = assets
                }else{
                    finalAssets = links?.assets?.block
                }
                const asset = finalAssets?.length > 0 && finalAssets?.find(asset => asset?.url?.includes(assetId))
                if (!asset) {
                    return <div key={ `missing_asset_${index}` } className="text-red-500">Asset not found</div>      
                }       
                const fileType = checkFileType(asset.fileName)
                const fileUrl = asset.url
                const fileName = asset.fileName

                if (fileType === "image") {
                    return (
                        <img
                            key={ `image_${index}` }
                            alt={ fileName }
                            src={ fileUrl }
                            className="mt-[5px] mb-[5px]"
                        />
                    )
                } else if (fileType === "video") {
                    return (
                        <div
                            key={ `video_${index}` }
                            className="w-[100%] px-[8px] z-[5] relative mt-[5px] mb-[5px] justify-center"
                        >
                            <ReactPlayer
                                className="w-[100%] shadow-2xl shadow-[#16093E] items-stretch justify-center"
                                controls={ true }
                                url={ fileUrl }
                            />
                        </div>
                    )
                } else if (fileType === "document") {
                    if(fileName.endsWith(".pdf")){
                        return (
                            <iframe
                                title="pdfdocument"
                                key={ `document_${index}` }
                                src={ fileUrl }
                                width={ "100%" }
                                className="mt-[5px] mb-[5px] w-[100%] h-[100vh] shadow-2xl shadow-[#16093E] border-2"
                            />
                        )
                    } else {
                        return (
                            <a 
                                key = { `document_${index}` }
                                href={ fileUrl }
                                download={ fileName }
                                className="text-primary-50 underline mt-[10px] mb-[10px] block"  
                            >     
                                { fileName }                                  
                            </a>
                        )
                    }
                }
                return null
            }
            default:      
                return null    
            }
        })
    }

    const generateClassNames = (styles, isparentCall, isfirstcall = false) => {
        let css = isparentCall && !isfirstcall ? "mt-6 w-full" : ""
        styles?.map((style) => {
            switch (style.type) {
            case "italic":
                css += css.trim() === "" ? "italic" : " italic"
                break
            case "bold":
                css +=
                        css.trim() === ""
                            ? "font-bold text-secondary-50"
                            : " font-bold text-secondary-50"
                break
            case "underline":
                css += css.trim() === "" ? "underline" : " underline"
                break
            }
        })
        return css
    }

    const imageExtensions = ["jpg", "jpeg", "gif", "png", "svg", "tiff", "raw", "bmp"]
    const docExtensions = ["pdf", "docx", "doc", "xls", "xlsx"]
    const videoExtensions = ["mp4", "mov", "wmv", "avi", "mkv", "webm", "mpeg"]

    function checkFileType(filename) {
        const fileExtension = filename?.split(".").slice(-1).pop()?.toLowerCase()
        let fileType = "image"
        if (imageExtensions.includes(fileExtension)) {
            fileType = "image"
        }
        if (docExtensions.includes(fileExtension)) {
            fileType = "document"
        }
        if (videoExtensions.includes(fileExtension)) {
            fileType = "video"
        }
        return fileType  
    }

    return (
        <>
            { renderHtmlRecursive(contents, links?.assets?.block, true) }
            { contents && regFileViewer(contents) }
        </>
    )
}

export default React.memo(MultiTagRender)
